import { render, staticRenderFns } from "./BetSummary.vue?vue&type=template&id=605460e2&"
import script from "./BetSummary.vue?vue&type=script&lang=js&"
export * from "./BetSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports